<ng-template #empty>
  <app-discharged-itinerary [isTicketOpen]="isTicketOpen"> </app-discharged-itinerary>
</ng-template>

<div *ngIf="!!segments?.length; else empty">
  <div class="columns mb-1pt is-vcentered">
    <div class="column">
      <app-checkbox [isChecked]="allSelected" label=" {{ 'itinerary-info.segments-info.title' | translate }}"
        (checked)="selectAll($event)" id="selectAll" side="left" [checkboxVisible]="canSelect"
        [bold]="true"></app-checkbox>
    </div>

    <div *ngIf="encryptedFare" class="column pb-0">
      <div class="">
        <span class="has-text-grey is-size-7 mr-3">
          <span>{{ 'itinerary-info.segments.fare-info' | translate }}: </span>
          <span (click)="selectText($event)">{{ encryptedFare }}</span>
        </span>
      </div>
    </div>

    <div class="column pb-0">
      <div class="is-pulled-right">
        <span *ngIf="endorsement" class="has-text-grey is-size-7 mr-3">
          <ng-container *ngIf="endorsement?.includes('|'); else endorsementTpl">
            <strong class="is-block" style="font-weight: 500;">
              {{ endorsement?.split('|')[1]?.trim() }}
              {{ 'itinerary-info.segments.isAllowedVol' | translate }}
            </strong>

            <span>{{ 'itinerary-info.segments.original-endorsement' | translate }}: </span>

            <span (click)="selectText($event)">
              {{ endorsement?.split('|')[0]?.trim() }}
            </span>
          </ng-container>

          <ng-template #endorsementTpl>
            <span>
              {{ 'itinerary-info.segments.original-endorsement' | translate }}: {{ endorsement }}
            </span>
          </ng-template>
          <span *ngIf="segments[0]?.validatingCarrier" [attr.data-title]="'Validating Carrier'"
            class="has-text-grey is-size-7" (click)="selectText($event)">
            ({{ segments[0].validatingCarrier.code }}) -
            {{ segments[0].validatingCarrier.name }}
          </span>
          <ng-template #plainEndorsement>
            <span (click)="selectText($event)">{{ endorsement }}</span>
          </ng-template>
        </span>

      </div>
    </div>
  </div>

  <ng-container *ngFor="let segment of segments; let i = index">
    <div class="pb-3">
      <app-segment-info [segment]="segment" [index]="i" [mode]="mode" [baggageAllowance]="baggageAllowance"
        [isMultidestiny]="isMultidestiny" [canSelect]="canSelect" (selected)="selecteds($event, i)"
        (openSyncForm)="openSyncForm($event)"
        (loadAlternatives)="loadAlternativesInvoluntary($event)"></app-segment-info>
    </div>
  </ng-container>

  <div *ngIf="isDevelop" class="received-alert-container">
    <app-alert type="warning">
      <span class="weight-medium" title> {{ 'shared.dev-mode.title' | translate }} </span>
      <div description>
        {{ 'shared.dev-mode.description.disable-received-from-required' | translate }}
      </div>
    </app-alert>
  </div>

  <form [formGroup]="receivedFromForm">
    <div class="center">
      <app-input-field class="flex-grow-1 pr-2" [form]="receivedFromForm" type="text" [uppercase]="true"
        inputName="receivedFrom" maxLength="20" [tall]="true"
        label="{{ 'itinerary-info.segments.received-from' | translate }}"
        errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}">
      </app-input-field>

      <div class="button-container">
        <app-input-submit inputText="{{
            isPreviousReceivedFrom ? ('shared.clear' | translate) : ('shared.save' | translate)
          }}" type="submit" [disabled]="!receivedFromForm.valid && !isPreviousReceivedFrom"
          [isDanger]="isPreviousReceivedFrom"
          (clickButton)="isPreviousReceivedFrom ? removeReceivedFrom() : saveReceivedFrom()"></app-input-submit>
      </div>
    </div>
  </form>
</div>

<app-sync-ticket-form [open]="syncForm" [isReIssueFlow]="isReIssueFlow"
  (closeSyncForm)="syncForm = false"></app-sync-ticket-form>